import React from 'react'
import HeaderComp from '../common/header/HeaderComp'
import FooterComp from '../common/footer/FooterComp'
import { CDN_URL } from '../../../config/config'

const Clients = () => {
  return (
    <div>
        <HeaderComp/>
            <section>
                <div className='container'>
                    <div className='row py-5'>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/1.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/2.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/3.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/4.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/5.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/6.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/7.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/8.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/9.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/10.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/11.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/12.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/13.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/14.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/15.webp'} alt="client-img"/>
                        </div>
                        <div className='col-6 col-md-4 col-lg-2 col-xl-2 client-img border'>
                            <img src={CDN_URL+'visaka/vnext/website/assets/images/clients/16.webp'} alt="client-img"/>
                        </div>


                    </div>
                    
                </div>
            </section>
        <FooterComp/>
    </div>
  )
}

export default Clients